import React from 'react';
import { StaticQuery, graphql, Link } from 'gatsby';
import Img from 'gatsby-image';
import styled from 'styled-components';
import colors from '../../styles/colors';
import { Container, Row, Col } from 'react-bootstrap';

const BaseSpotlight = ({ data, className, content }) => (
  <div className={className}>
    <Container>
      <Row>
        <Col xs={12} lg={8}>
          <div className='column-text'>
            <div className='spotlight-meta'>
              <span className='spotlight-title'>{content.title}:</span>{' '}
              <span className='spotlight-name'>{content.project}</span>
            </div>
            {content.bodyText.map((text, index) => (
              <p key={index}>{text}</p>
            ))}
            <Link className='read-more' to='/projects/'>
              <span className='buttonText'>Read More &raquo;</span>
            </Link>
          </div>
        </Col>
        <Col xs={12} lg={4}>
          <div className='column-image'>
            <Img /*fixed={data.project.childImageSharp.fixed}*/ fluid={data.project.childImageSharp.fluid} />
          </div>
        </Col>
      </Row>
    </Container>
  </div>
);

const Spotlight = styled(BaseSpotlight)`
  width: 100%;
  align-self: flex-start;
  background-color: ${colors.lightBlue};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 40px;
  @media screen and (max-width: 992px){
    padding-right: 5px;
  }
  /* @media screen and (max-width: 568px){
    padding: 10px;
  } */
  .spotlight-meta {
    margin-bottom: 5px;
  }
  .spotlight-title {
    text-transform: uppercase;
  }
  .spotlight-name {
    text-transform: uppercase;
    font-weight: bold;
  }

  .column-text,
  .column-image {
    width: 100%;
    /* @media screen and (max-width: 576px){
      width: 100%
    } */
  }
  .column-image {
    padding: 40px;
    padding-right: 10px;
    @media screen and (max-width: 992px) {
      /* display: none; */
      padding-left: 5px;
      max-width: 300px;
    }
  }

  .read-more {
    background-color: transparent;
    text-transform: uppercase;
    align-self: flex-start;
    border: 1px solid ${colors.darkGray};
    color: ${colors.darkGray};
    padding: 5px;
    text-decoration: none;

    .buttonText {
      vertical-align: middle;
    }
  }

  p {
    color: ${colors.copyColor};
  }
`;

export default props => (
  <StaticQuery
    query={graphql`
      query {
        project: file(relativePath: { eq: "spotlight-merchants.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 230) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `}
    render={data => <Spotlight data={data} {...props} />}
  />
);
